import { ref, onMounted, onUnmounted } from 'vue';

type UseTypewriterOptions = {
  words: string[];
  typeSpeed?: number;
  deleteSpeed?: number;
  delayBetweenWords?: number;
  loop?: boolean;
};

export function useTypewriter(options: UseTypewriterOptions) {
  const {
    words,
    typeSpeed = 100,
    deleteSpeed = 50,
    delayBetweenWords = 1500,
    loop = true,
  } = options;

  const displayed = ref('');
  const isTyping = ref(true);
  const wordIndex = ref(0);

  let charIndex = 0;
  let timeout: ReturnType<typeof setTimeout>;

  function type() {
    const currentWord = words[wordIndex.value];

    if (!currentWord) return;

    if (isTyping.value) {
      charIndex++;
      displayed.value = currentWord.slice(0, charIndex);

      if (charIndex === currentWord.length) {
        isTyping.value = false;
        timeout = setTimeout(type, delayBetweenWords);
        return;
      }

      timeout = setTimeout(type, typeSpeed);
    } else {
      charIndex--;
      displayed.value = currentWord.slice(0, charIndex);

      if (charIndex === 0) {
        isTyping.value = true;
        wordIndex.value++;

        if (wordIndex.value >= words.length) {
          if (loop) {
            wordIndex.value = 0;
          } else {
            return;
          }
        }
      }

      timeout = setTimeout(type, deleteSpeed);
    }
  }

  function start() {
    stop();
    type();
  }

  function stop() {
    clearTimeout(timeout);
  }

  onMounted(start);
  onUnmounted(stop);

  return {
    displayed,
    start,
    stop,
  };
}